<script lang="ts">
	import { Text } from '@Shelly/shelly-design-system';
	import { load_image_from } from 'src/helpers/interface_helpers';
	import type { DashCameraLayout } from '../../dash-types';

	export let cameras: { id: string; name: string }[] = [];
	export let layout: DashCameraLayout = 'single';

	const placeholderSrc = load_image_from('images/device_images/logo_white_S.png');

	$: focusCamera = cameras[0];
	$: sideCameras = cameras.slice(1);
	$: fillsSingleColumn = cameras.length <= 1;
</script>

{#if layout === 'single'}
	<div class="wizard-camera-preview single">
		{#if cameras[0]}
			<div class="wizard-player-cell">
				<img src={placeholderSrc} alt="" class="wizard-player-logo" />
				{#if cameras[0].name}
					<Text styleType="body-extra-small" class="text-white wizard-player-name" noWrap>
						{cameras[0].name}
					</Text>
				{/if}
			</div>
		{/if}
	</div>
{:else if layout === 'pair' || layout === 'quad'}
	<div
		class="wizard-camera-preview"
		class:pair={layout === 'pair'}
		class:quad={layout === 'quad'}
		class:single-col={fillsSingleColumn}
	>
		{#each cameras as camera (`preview-${camera.id}`)}
			<div class="wizard-player-cell">
				<img src={placeholderSrc} alt="" class="wizard-player-logo" />
				<Text styleType="body-extra-small" class="text-white wizard-player-name" noWrap>
					{camera.name}
				</Text>
			</div>
		{/each}
	</div>
{:else if layout === 'triple-focus'}
	<div class="wizard-camera-preview trio">
		{#if focusCamera}
			<div class="wizard-trio-main">
				<div class="wizard-player-cell">
					<img src={placeholderSrc} alt="" class="wizard-player-logo" />
					<Text styleType="body-extra-small" class="text-white wizard-player-name" noWrap>
						{focusCamera.name}
					</Text>
				</div>
			</div>
		{/if}
		{#if sideCameras.length > 0}
			<div class="wizard-trio-side">
				{#each sideCameras as camera (`side-${camera.id}`)}
					<div class="wizard-player-cell">
						<img src={placeholderSrc} alt="" class="wizard-player-logo" />
						<Text styleType="body-extra-small" class="text-white wizard-player-name" noWrap>
							{camera.name}
						</Text>
					</div>
				{/each}
			</div>
		{/if}
	</div>
{/if}

<style>
	.wizard-camera-preview {
		width: 100%;
		max-width: 360px;
	}

	.wizard-camera-preview.pair,
	.wizard-camera-preview.quad {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: var(--spacing-xs);
	}

	.wizard-camera-preview.pair.single-col,
	.wizard-camera-preview.quad.single-col {
		grid-template-columns: 1fr;
	}

	.wizard-camera-preview.trio {
		display: grid;
		grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
		gap: var(--spacing-xs);
		width: 100%;
	}

	.wizard-trio-side {
		display: grid;
		grid-template-rows: 1fr 1fr;
		gap: var(--spacing-xs);
		min-width: 0;
	}

	.wizard-player-cell {
		position: relative;
		width: 100%;
		aspect-ratio: 16 / 9;
		border-radius: var(--radius-small);
		overflow: hidden;
		display: flex;
		align-items: center;
		justify-content: center;
		background: var(--color-1);
	}

	.wizard-player-logo {
		width: 28%;
		height: auto;
		opacity: 0.85;
	}

	.wizard-player-cell :global(.wizard-player-name) {
		position: absolute;
		left: var(--spacing-xs);
		bottom: var(--spacing-xs);
		max-width: calc(100% - var(--spacing-s));
	}

	@media (max-width: 639px) {
		.wizard-camera-preview.trio {
			grid-template-columns: 1fr;
		}

		.wizard-trio-side {
			grid-template-columns: 1fr 1fr;
			grid-template-rows: auto;
		}
	}
</style>
